export default __webpack_public_path__ + "static/media/satelite.49a4f451.png";